import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LayoutGridType } from '@ag-common-lib/lib/lists/layout/layout-grid-type.enum';

@Component({
  selector: 'ag-shr-editor-toolbar',
  templateUrl: './ag-editor-toolbar.component.html',
  styleUrls: ['./ag-editor-toolbar.component.scss'],
})
export class AgEditorToolbarComponent {
  @Input() title: string;
  @Input() type: LayoutGridType = LayoutGridType.short;
  @Input() isEditVisible = true;
  @Input() agentDbId: string | null | undefined;
  @Output() clickEdit = new EventEmitter<boolean>();
  protected readonly LayoutGridType = LayoutGridType;
}
